import EncountersTag from "./encounters-tag"
import EmptyState from "./empty-state"

export default function EncountersDetailsAppointments({appointments}:{appointments:any}) {
  console.log('appointments',appointments)
    return (
        <div className="flex flex-col gap-[8px] px-[16px]">
                {appointments?.length && appointments?.length > 0 ? appointments?.map((appointment:any, index:number) => (
                  <div key={index} className="border border-[#0404041A] rounded-[12px] p-[16px] flex justify-between ">
                      <div className="flex flex-col gap-[8px]">
                      <h1 className="text-[#1A202C] text-[16px] font-medium leading-[137%] tracking-[-1%]">{appointment?.name}</h1>
                      <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Date:5/20/2024</span>
                      </div>         
                      <div>                
                        <EncountersTag type="missed" />
                    </div>         
                  </div>
                )) : <EmptyState title="No appointment available" message="You haven’t booked an appointment yet." type="appointment" />}

          {appointments?.map((appointment:any, index:number) => (
             <div key={index} className="border border-[#0404041A] rounded-[12px] p-[16px] flex justify-between ">
                <div className="flex flex-col gap-[8px]">
                <h1 className="text-[#1A202C] text-[16px] font-medium leading-[137%] tracking-[-1%]">{appointment?.name}</h1>
                 <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Date:5/20/2024</span>
                </div>         
                 <div>                
                   <EncountersTag type="missed" />
</div>         
            </div>
          ))}
        </div>
    )
}